let dropdownLoaded = false

const { getElement } = window.BAO.Utils

class HeaderDropdown extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.lastTouched = null
    this.hasBeenOpened = false

    if (dropdownLoaded) return

    window.BAO.sectionRenderer
      .fetch('header', `${window.Shopify.routes.root}?view=dropdown`)
      .then((res) => {
        dropdownLoaded = true

        const newDOM = window.BAO.sectionRenderer.convertToDOM(res.header)
        const myself = newDOM.querySelector('header-dropdown .hd-Banner_Items')
        this.querySelector('.hd-Banner_Items').outerHTML = myself.outerHTML

        this.onItemEnter = this.onItemEnter.bind(this)
        this.onItemLeave = this.onItemLeave.bind(this)

        this.els?.item?.elements.forEach((itemEl) => {
          this.listeners.add(itemEl, 'mouseover', this.onItemEnter)
          this.listeners.add(itemEl, 'mouseleave', this.onItemLeave)
        })
      })
      .catch(() => {})
  }

  setupListeners () {
    super.setupListeners()

    if (
      document.querySelector('[data-header-dropdown-el="menu-dropdown-toggle"]')
    ) {
      document.addEventListener(
        'click',
        this.handleToggleButtonClick.bind(this),
      )

      this.els?.item?.elements.forEach((itemEl) => {
        const menuDropdownEl = getElement(
          '[data-header-dropdown-el="menu-dropdown"]',
          { context: itemEl },
        )

        if (!menuDropdownEl) return

        const menuLinkEl = getElement('.hd-Banner_Link', { context: itemEl })

        this.listeners.add(
          menuLinkEl,
          'touchstart',
          this.handleToggleButtonTouchStart,
        )
      })
    }

    document.addEventListener('focusin', this.handleFocusIn.bind(this))

    document.addEventListener(
      'focukeyupsin',
      this.handleEscapePress.bind(this),
    )
  }

  onItemEnter (event) {
    const item = event.target.closest('[data-header-dropdown-el="item"]')

    if (!item) return

    if (this.hasBeenOpened === false) {
      document.dispatchEvent(new CustomEvent('nav-open'))
      document.body.classList.add('util-NavOpen')

      this.hasBeenOpened = true
    }
  }

  onItemLeave (event) {
    const item = event.target.closest('[data-header-dropdown-el="item"]')

    if (!item) return

    document.body.classList.remove('util-NavOpen')
    this.hasBeenOpened = false
  }

  /**
   * @param {ClickEvent} event
   *
   * @returns {void}
   */
  handleToggleButtonTouchStart (event) {
    if (this.lastTouched === this.innerText) return

    event.preventDefault()

    this.lastTouched = this.innerText
  }

  /**
   * @param {ClickEvent} event
   *
   * @returns {void}
   */
  handleToggleButtonClick (event) {
    if (
      !event.target.closest('[data-header-dropdown-el="menu-dropdown-toggle"]')
    ) {
      return
    }

    const menuToggleEl = event.target
    const parentItemEl = menuToggleEl.closest(this.els?.item?.selector)
    if (!parentItemEl) return
    const menuDropdownEl = getElement(this.els?.['menu-dropdown']?.selector, {
      context: parentItemEl,
    })
    const isExpanded = menuDropdownEl.getAttribute('aria-expanded') === 'true'

    if (isExpanded) {
      menuToggleEl.removeAttribute('data-active')
      menuDropdownEl.removeAttribute('aria-expanded')
    } else {
      menuToggleEl.setAttribute('data-active', 'true')
      menuDropdownEl.setAttribute('aria-expanded', 'true')

      document.body.classList.add('util-NavOpen')
      document.dispatchEvent(new CustomEvent('nav-open'))
    }
  }

  /**
   * @param {FocusInEvent} event
   *
   * @returns {void}
   */
  handleFocusIn (event) {
    if (
      event.target.closest(this.localName) &&
      !event.target.closest('[aria-expanded="true"]')
    ) {
      // This ensures an expanded dropdown closes when the user tabs out of it but focus remains within the header-dropdown element
      this.closeDropdowns()
    }

    if (!event.target.closest(this.localName)) {
      // This ensures all dropdowns are closed when focus leaves the header-dropdown element
      this.closeDropdowns()
    }
  }

  /**
   * @param {KeyboardEvent} event
   *
   * @returns {void}
   */
  handleEscapePress (event) {
    if (event.code?.toUpperCase() !== 'ESCAPE') return
    this.closeDropdowns()
  }

  /**
   * @returns {void}
   */
  closeDropdowns () {
    if (this.els?.['menu-dropdown-toggle']?.exists) {
      this.els?.['menu-dropdown-toggle']?.elements.forEach((menuDropdownEl) => {
        menuDropdownEl.removeAttribute('data-active')
      })
    }

    if (this.els?.['menu-dropdown']?.exists) {
      this.els?.['menu-dropdown']?.elements.forEach((menuDropdownEl) => {
        menuDropdownEl.removeAttribute('aria-expanded')
      })
    }

    document.body.classList.remove('util-NavOpen')
    this.hasBeenOpened = false
  }
}

if (!customElements.get('header-dropdown')) {
  customElements.define('header-dropdown', HeaderDropdown)
}
